import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=86cf9448&"
import script from "./StatisticsCard.vue?vue&type=script&lang=ts&"
export * from "./StatisticsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports